import React from 'react';
import logo_mail from './sendmail.svg';
import '../../App.css';


class Sendmail extends React.Component {
  constructor(props) {
    super(props);
  }

   render() {
   return (
 
    <div class="card">
      <img src={logo_mail} class="card-img-top" alt="Imagen de envio de EMAILs en formato SVG"/>
      <div class="card-body">
        <hr></hr>
        <h3 class="card-title">Envio MAIL</h3>
        <h5><p class="card-text">Funcionalidad para el envio de campañas por MAIL.</p></h5>
        <a href="." class="btn btn-primary">Inicio</a>
      </div>
    </div>
   );
    
  }
 
}
 
export default Sendmail;

/*
         <img src={logo} class="card-img-top" alt="logo"/>
*/
         